import axios from '@/api/$axios'
export default {
  detail () {
    return axios.get(`/system_config`)
  }
}
